export const EventSenderToken = Symbol('EventSender');
export const LocalizationRepositoryToken = Symbol('LocalizationRepository');
export const ResourceLoaderToken = Symbol('ResourceLoader');
export const NewsControllerToken = Symbol('NewsController');
export const ChatControllerToken = Symbol('ChatController');
export const CurrentUserRepositoryToken = Symbol('CurrentUserRepository');
export const FormControllerToken = Symbol('FormController');
export const CurrentFacilityRepositoryToken = Symbol('CurrentFacilityRepository');
